import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Check from '@wix/da-ds/pkg/Icons/Check';
import Error from '@wix/da-ds/pkg/Icons/24x24/Error';
import { genericUndoAction } from '../../Notifications/redux/actionCreators';
import SystemNotification from '../../SystemNotification';
import Notification from '../Notification';
export const GenericUndoNotification = ({ id, queueName, message, messageLocaleKey, messageLocaleOptions, isError = false, cardProps = {} })=>{
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const onUndo = useCallback(()=>{
        dispatch(genericUndoAction());
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ React.createElement(Notification, {
        id: id,
        queueName: queueName,
        cardComponent: SystemNotification,
        cardProps: _object_spread_props(_object_spread({
            iconComponent: isError ? Error : Check,
            isError
        }, cardProps), {
            actions: [
                onUndo && {
                    type: 'positive',
                    label: t('common.undo'),
                    onClick: onUndo,
                    closeOnClick: true
                },
                ...(cardProps === null || cardProps === void 0 ? void 0 : cardProps.actions) || []
            ]
        })
    }, message !== null && message !== void 0 ? message : t(messageLocaleKey !== null && messageLocaleKey !== void 0 ? messageLocaleKey : '', messageLocaleOptions));
};
GenericUndoNotification.displayName = 'GenericUndoNotification';
export default GenericUndoNotification;
